module.exports = __webpack_public_path__ + "static/media/favourite.2204dde8.svg";